import {useMemo} from "react";
import {jwtDecode} from "jwt-decode";
import {JwtPayloadType} from "@bounce/shared/contexts";

type ReachAuth = {
  agentEmail: string | undefined;
};

export const useReachAuth = (): ReachAuth => {
  const agentToken = localStorage.getItem("agentToken") || "";

  const decodedToken = useMemo<JwtPayloadType | undefined>(() => {
    if (!agentToken) return undefined;
    try {
      return jwtDecode<JwtPayloadType>(agentToken);
    } catch {
      return undefined;
    }
  }, [agentToken]);

  return {agentEmail: decodedToken?.sub};
};
